import { Device } from 'DeviceUtils';
import { useRef } from 'react';
import { TIMESHIFT_EPG_OFFSET_MILLIS } from '../../../../options';

// TODO: Rewrite into TS and add TYPES

class ProgramTimeline {
    constructor(api, initialChannelId) {
        this.api = api;
        this.limit = 10;
        this.channels = [];
        this.channelId = initialChannelId;
        this.channelPrograms = [];
        this.channelProgramsInterval = {
            from: null,
            to: null
        };
        this.loading = false;
    }

    setChannelId = (channelId) => {
        this.channelId = channelId;
    };

    fetchPrograms = async (from, to) => {
        this.loading = true;
        try {
            this.channelProgramsInterval = { from, to };
            const response = await this.api.fetchEpg({
                channelIds: this.channelId.toString(),
                from: to - TIMESHIFT_EPG_OFFSET_MILLIS,
                to,
                offset: 0,
                limit: 10
            });
            const [firstItem] = response.items;
            this.channelPrograms = firstItem?.programs || [];
        } catch (error) {
            console.log('in ProgramTimeline.js: fetchPrograms>         ', error);
        } finally {
            this.loading = false;
        }
    };

    fetchLiveProgram = async () => {
        this.loading = true;
        try {
            const now = Date.now();
            const response = await this.api.fetchEpg({
                channelIds: this.channelId.toString(),
                from: now,
                to: now + 5 * 60 * 1000,
                offset: 0,
                limit: 10
            });

            const [firstItem] = response.items;
            const [liveProgram] = firstItem?.programs || this.channelPrograms.slice(-1) || [];
            if (!liveProgram) return null;
            const resultProgramItem = await this.api.fetchProgramDetail({
                channelId: this.channelId
            });
            this.channelPrograms = [resultProgramItem];
            return resultProgramItem;
        } catch (error) {
            console.log('in ProgramTimeline.js: fetchLiveProgram>         ', error);

            return null;
        } finally {
            this.loading = false;
        }
    };

    getLiveProgram = async () => this.findProgramAtTime(Date.now());

    getCurrentProgram = async (seekTime) => {
        const dateUnix = seekTime * 1000;
        const actualSeekTime = Device.isWeb
            ? dateUnix
            : this.channelProgramsInterval.from + dateUnix;

        return this.findProgramAtTime(actualSeekTime);
    };

    findProgramAtTime = (time) => {
        console.log('findProgramAtTime', this.channelPrograms);
        return this.channelPrograms.find(
            (program) => time >= program.getStartTime() && time <= program.getEndTime()
        );
    };
}

export const useProgramTimeline = (api, currentChannel) => {
    const livePrograms = useRef(new ProgramTimeline(api, currentChannel));
    return livePrograms.current;
};
